<template>
  <div v-if="!loggedIn">
    <form @submit.prevent="login">
      <label>
        Username:
        <input type="text" v-model="loginData.username">
      </label>
      <label>
        Password:
        <input type="text" v-model="loginData.password">
      </label>
      <label>
        Server URI:
        <input type="text" v-model="loginData.server">
      </label>
      <button type="submit">
        Init
      </button>
    </form>
  </div>
  <div v-else>
    <div>
      <select @change="onChangeMicrophone" :value="getSelectedInputDevice">
        <option v-for="mic in getInputDeviceList"
                :value="mic.deviceId"
                :key="mic.deviceId"
                :selected="getSelectedInputDevice === mic.deviceId">
          {{ mic.label }}
        </option>
      </select>
      <br/>
      <select @change="onChangeSpeakers" :value="getSelectedOutputDevice">
        <option v-for="device in getOutputDeviceList"
                :value="device.deviceId"
                :key="device.deviceId"
                :selected="getSelectedOutputDevice === device.deviceId">
          {{ device.label }}
        </option>
      </select>
    </div>
    <br>
    <div>
      DND
      <input type="checkbox" id="isDND" :value="isDND" :checked="isDND" @change="onDNDChange">
    </div>
    <div>
      <button v-if="isMuted"
              @click="doMute(false)">
        Unmute
      </button>
      <button v-else
              @click="doMute(true)">
        Mute
      </button>
    </div>
    <br>
    <div>
      <form @submit.prevent="makeCall">
        <label>
          Your target:
          <input type="text" v-model="target">
        </label>
        <button :disabled="callAddingInProgress !== null">
          Call
        </button>
      </form>
    </div>
    <br>
    <div>
      Active calls: {{ Object.keys(getActiveCalls).length }}
      <p>Your room: </p>
      <select @change="setCurrentActiveRoom(parseInt($event.target.value))">
        <option value="" :selected="getCurrentActiveRoomId === null">No room selected</option>
        <option v-for="room in activeRoomList"
                :value="room.roomId"
                :key="room.roomId"
                :selected="getCurrentActiveRoomId === room.roomId">
          Room {{ room.roomId }}
        </option>
      </select>
    </div>
    <br>
    <p>RoomList</p>
    <br>
    <div v-for="room in activeRoomList" :key="room.roomId">
      <b>Room {{ room.roomId }}</b>:({{ room.started }})
      <br>
      <ul>
        <li v-for="(call, index) in activeCallsInRoom(room.roomId)" :key="index">
          <span v-if="call.audioQuality">Quality:</span>
          <audio-quality-indicator :value="call.audioQuality" :callId="call._id"/>
          <b>{{ call._remote_identity }}</b>
          <volume-level-indicator v-if="call.audioTag"
                                  :stream="call.audioTag.srcObject"
                                  :callId="call._id"/>
          <button @click="callTerminate(call._id)">Hangup</button>
          <button @click="transferCall(call._id)">Transfer</button>
          <button v-if="activeCallsInRoom(room.roomId).length === 2" @click="callMerge(room.roomId)">Merge {{room.roomId}}</button>

          <button v-if="call._localHold"
                  :disabled="getCurrentActiveRoomId !== call.roomId"
                  @click="doCallHold({callId: call._id, toHold: false})">
            UnHold
          </button>
          <button v-else
                  :disabled="getCurrentActiveRoomId !== call.roomId || call.status === CONSTRAINTS.CALL_STATUS_UNANSWERED"
                  @click="doCallHold({callId: call._id, toHold: true})">
            Hold
          </button>

          <button v-if="call.direction !== 'outgoing' && !call._is_confirmed" @click="callAnswer(call._id)">
            Answer
          </button>

          <select @change="callMove({callId: call._id, roomId: parseInt($event.target.value)})">
            <option v-for="room in activeRoomList"
                    :value="room.roomId"
                    :key="room.roomId"
                    :selected="call.roomId === room.roomId">
              Room {{ room.roomId }}
            </option>
          </select>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
//import vsip from '@voicenter-team/vsip';
import {CONSTRAINTS} from '@voicenter-team/vsip/config/enum'
import VolumeLevelIndicator from "./VolumeLevelIndicator";
import AudioQualityIndicator from "./AudioQualityIndicator";

export default {
  name: 'SimpleBeautifulPhone',
  components: {
    VolumeLevelIndicator,
    AudioQualityIndicator
  },
  data() {
    return {
      target: '665',
      loginData: {
        username: '',
        password: '',
        server: ''
      },
      loggedIn: false,
      CONSTRAINTS: CONSTRAINTS
    }
  },
  computed: {
    ...mapGetters('vsip', [
      'getActiveCalls',
      'callAddingInProgress',
      'getCurrentActiveRoomId',
      'getActiveRooms',
      'getInputDeviceList',
      'getOutputDeviceList',
      'getSelectedInputDevice',
      'getSelectedOutputDevice',
      'isDND',
      'isMuted'
    ]),
    activeRoomList() {
      return Object.values(this.getActiveRooms)
    }
  },
  methods: {
    ...mapActions('vsip', [
      'removeListener',
      'subscribe',
      'setCurrentActiveRoom',
      'callChangeRoom',
      'callAnswer',
      'doCallHold',
      'callTerminate',
      'callMerge',
      'callMove',
      'callTransfer',
      'init',
      'setMediaDevices',
      'setSpeaker',
      'setMicrophone',
      'doCall',
      'setDND',
      'doMute'
    ]),
    login() {
      this.init({
        configuration: {
          session_timers: false,
          uri: `sip:${this.loginData.username}@${this.loginData.server}`,
          password: this.loginData.password,
        },
        socketInterfaces: [
          `wss://${this.loginData.server}`
        ],
        sipDomain: 'sip02.voicenter.co',
        sipOptions: {
          session_timers: false,
          extraHeaders: ['X-Bar: bar'],
          pcConfig: {'iceServers': []}
        }
      });

      this.subscribe({
        type: 'new_call',
        listener: (call, event) => {
          console.log('NEW CALL!!!!', call, event)

          if (call.direction === 'incoming') {
            this.playBeep();
          }
        }
      });
      this.subscribe({
        type: 'confirmed',
        listener: (call, event) => {
          console.log('CALL CONFIRMED!!!!', call, event)
        }
      });
      this.subscribe({
        type: 'failed',
        listener: (call, event) => {
          console.log('CALL FAILED!!!!', call, event)
        }
      });
      this.subscribe({
        type: 'progress',
        listener: (call, event) => {
          console.log('CALL PROGRESS!!!!', call, event)
        }
      });
      this.subscribe({
        type: 'ended',
        listener: (call, event) => {
          console.log('CALL ENDED!!!!', call, event)
        }
      });

      this.loggedIn = true
    },
    transferCall(callId) {
      const target = prompt('Please enter target:');

      if (target !== null || target !== '') {
        this.callTransfer({callId, target})
      }
    },
    activeCallsInRoom(roomId) {
      return Object.values(this.getActiveCalls).filter((call) => call.roomId === roomId)
    },
    onChangeSpeakers({target}) {
      this.setSpeaker(target.value);
    },
    onChangeMicrophone({target}) {
      this.setMicrophone(target.value);
    },
    makeCall() {
      this.doCall(this.target)
    },
    playBeep() {
      let snd = new Audio("data:audio/wav;base64,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");
      // repeat with the interval of 2 seconds
      let timerId = setInterval(() => {
        snd.play();
        console.log('incoming call ... ring ring ring ....');
      }, 1000);
      // after 5 seconds stop
      setTimeout(() => {
        clearInterval(timerId);
      }, 5000);
    },
    onDNDChange() {
      this.setDND(!this.isDND)
    },
  },
  async mounted() {
    if (!this.getInputDeviceList.length || !this.getOutputDeviceList.length) {
      await this.setMediaDevices()
    }
  }
}
</script>
